import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImageOne from "@/components/uploadImage";
import uploadImageTow from "@/components/uploadImage";
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor,
    uploadImageOne: uploadImageOne,
    uploadImageTow: uploadImageTow
  },
  data: function data() {
    return {
      dialogShow: false,
      form: {
        params: []
      }
    };
  },
  created: function created() {
    this.copyform = _objectSpread({}, this.form);
  },
  methods: {
    init: function init(datas) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                if (datas) {
                  data = JSON.parse(JSON.stringify(datas));
                  data.params.map(function (i) {
                    i.picfileList = [i.banner];
                    i.recharge_desc = _this.$utils.textRepl(i.recharge_desc);
                    i.picfileListMb = i.bannerMb ? [i.bannerMb] : '';
                  });
                  _this.form = _objectSpread({}, data);

                  _this.$nextTick(function () {
                    var dialogs_body = document.getElementsByClassName("dialogs_body");
                    dialogs_body.forEach(function (item) {
                      item.scrollTop = 0;
                    });
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};